var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEncryptedKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#063C4F",
    cx: 32,
    cy: 32,
    r: 32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4444444,24.8888889 C23.3435703,24.8888889 25.7796039,27.1548704 26.4705109,30.2216514 L38.2203399,30.2215948 L38.2222222,27.5555556 C38.2222222,26.573716 39.0181604,25.7777778 40,25.7777778 C40.9117082,25.7777778 41.6631238,26.4640714 41.7658174,27.3482291 L41.7777778,27.5555556 L41.7761046,30.2215948 L43.5549281,30.2215948 L43.5555556,27.5555556 C43.5555556,26.573716 44.3514938,25.7777778 45.3333333,25.7777778 C46.2450415,25.7777778 46.9964572,26.4640714 47.0991507,27.3482291 L47.1111111,27.5555556 L47.1106928,30.2215948 L48,30.2222222 C48.9818396,30.2222222 49.7777778,31.0181604 49.7777778,32 C49.7777778,32.9117082 49.0914841,33.6631238 48.2073264,33.7658174 L48,33.7777778 L26.4705109,33.7783486 C25.7796039,36.8451296 23.3435703,39.1111111 20.4444444,39.1111111 C17.008006,39.1111111 14.2222222,35.9273582 14.2222222,32 C14.2222222,28.0726418 17.008006,24.8888889 20.4444444,24.8888889 Z M20.4444444,28.4444444 C19.0851294,28.4444444 17.7777778,29.9385606 17.7777778,32 C17.7777778,34.0614394 19.0851294,35.5555556 20.4444444,35.5555556 C21.8037594,35.5555556 23.1111111,34.0614394 23.1111111,32 C23.1111111,29.9385606 21.8037594,28.4444444 20.4444444,28.4444444 Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEncryptedKey);
export default __webpack_public_path__ + "static/media/encrypted-key.9d4efae51df9b279321c91c15b620723.svg";
export { ForwardRef as ReactComponent };